<template>
  <v-container>
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.type"
      :timeout="3000"
      top
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-container fluid class="content-container">
      <div class="header-title">
        <div class="d-flex align-center">
          <h1 class="title-text">Companies</h1>
        </div>
      </div>

      <v-divider />

      <v-card class="header-card mb-4 mt-3">
        <v-row no-gutters align="center" class="px-4 py-3">
          <v-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
            <v-text-field
              v-model="search"
              solo
              flat
              dense
              placeholder="Find company..."
              prepend-inner-icon="mdi-magnify"
              clearable
              class="search-input"
              hide-details
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="12"
            md="6"
            class="d-flex justify-center justify-md-end"
          >
            <v-btn to="/companies/add" color="primary" class="action-button">
              <v-icon left>mdi-plus</v-icon>
              New Company
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="data-table-card">
        <v-data-table
          :headers="headers"
          :items="companies"
          :search="search"
          :loading="isLoading"
          :items-per-page="10"
          class="data-table"
        >
          <template v-slot:item.Status="{ item }">
            <v-chip
              :color="getStatusColor(item.Status)"
              small
              class="status-chip"
            >
              {{ item.Status }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="action-container">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="action-btn"
                    :to="`/companies/edit/${item._id}`"
                    small
                    color="info"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                  >
                    <v-icon size="12">mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="action-btn"
                    @click="confirmDelete(item)"
                    small
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                  >
                    <v-icon size="12">mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:no-data>
            <div class="empty-state">
              <v-icon size="48" color="grey">mdi-alert-circle-outline</v-icon>
              <div class="mt-2">No companies found</div>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <Foot />
  </v-container>
</template>
<script>
import axios from "axios";
import Foot from "@/components/Footer";
import Swal from "sweetalert2";

const url = require("@/client_config/config").url;

export default {
  name: "CompanyList",
  components: { Foot },

  data: () => ({
    headers: [
      {
        text: "Company Name",
        align: "start",
        value: "Name",
        width: "25%",
      },
      {
        text: "Address",
        value: "Address",
        width: "25%",
      },
      {
        text: "Email",
        value: "MailingAddress",
        width: "20%",
      },
      {
        text: "Phone",
        value: "Phone",
        width: "15%",
      },
      {
        text: "Status",
        value: "Status",
        width: "10%",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        align: "center",
      },
    ],
    search: "",
    companies: [],
    isLoading: true,
    snackbar: {
      show: false,
      type: "success",
      message: "",
    },
  }),

  created() {
    this.getCompanies();
  },

  methods: {
    getCompanies() {
      this.isLoading = true;
      axios
        .get(`${url}/companies`)
        .then((res) => {
          this.companies = res.data.companies;
        })
        .catch((error) => {
          this.showAlert("error", "Failed to load companies");
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    confirmDelete(item) {
      Swal.fire({
        title: "Delete Company",
        text: `Are you sure you want to delete ${item.Name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#d32f2f",
        cancelButtonColor: "#757575",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteCompany(item._id);
        }
      });
    },

    deleteCompany(id) {
      axios
        .delete(`${url}/companies/${id}`)
        .then(() => {
          this.showAlert("success", "Company deleted successfully");
          this.getCompanies();
        })
        .catch((error) => {
          this.showAlert("error", "Error deleting company");
          console.error(error);
        });
    },

    showAlert(type, message) {
      this.snackbar = {
        show: true,
        type,
        message,
      };
    },

    getStatusColor(status) {
      return (
        {
          Active: "success",
          Inactive: "error",
          Pending: "warning",
        }[status] || "grey"
      );
    },
  },
};
</script>

<style scoped>
.content-container {
  max-width: 1440px;
  margin: 0 auto;
}

.header-title {
  padding: 16px 0;
}

.title-text {
  font-size: 2rem;
  font-weight: 700;
  color: #102a43;
  margin: 0;
  letter-spacing: -0.5px;
}

.header-card {
  background: white;
  border: none;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.search-input {
  max-width: 420px;
  background: #f1f5f9;
  border-radius: 12px;
}

.search-input ::v-deep .v-input__slot {
  min-height: 44px !important;
  transition: background-color 0.2s ease;
}

.search-input:hover ::v-deep .v-input__slot {
  background-color: #e2e8f0;
}

.action-button {
  height: 44px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  border-radius: 12px;
  padding: 0 24px;
}

.data-table-card {
  border-radius: 16px;
  overflow: hidden;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.data-table ::v-deep .v-data-table__wrapper {
  border-radius: 16px;
}

.data-table ::v-deep thead th {
  font-size: 0.875rem;
  font-weight: 600;
  color: #334155;
  background: #f8fafc;
  text-transform: none;
  letter-spacing: 0;
  padding: 16px;
  border-bottom: 2px solid #e2e8f0;
}

.data-table ::v-deep tbody td {
  font-size: 0.9rem;
  color: #334155;
  height: 56px;
  padding: 12px 16px;
}

.data-table ::v-deep tbody tr:hover {
  background-color: #f8fafd;
}

.status-chip {
  font-size: 0.8125rem;
  font-weight: 600;
  padding: 0 12px;
  height: 24px;
}

.action-container {
  display: flex;
  gap: 6px;
  align-items: center;
}

.action-btn {
  border-radius: 4px;
  min-width: 28px !important;
  width: 28px;
  height: 28px;
  padding: 0 !important;
}

.empty-state {
  padding: 64px;
  text-align: center;
  color: #64748b;
}

@media (max-width: 600px) {
  .content-container {
    padding: 8px;
  }

  .header-title {
    padding: 12px 0;
  }

  .title-text {
    font-size: 1.5rem;
  }

  .search-input {
    max-width: 100%;
  }

  .action-button {
    width: 100%;
  }

  .data-table ::v-deep .v-data-table__wrapper {
    overflow-x: auto;
  }

  .data-table ::v-deep thead th,
  .data-table ::v-deep tbody td {
    padding: 8px;
    font-size: 0.875rem;
  }

  .action-container {
    flex-wrap: nowrap;
    justify-content: center;
  }

  .header-card,
  .data-table-card {
    border-radius: 12px;
  }
}

@media (min-width: 601px) and (max-width: 960px) {
  .content-container {
    padding: 16px;
  }

  .search-input {
    max-width: 100%;
  }
}
</style>
